<div class="error_container">
  <div class="bordered_wrapper">
    <div class="error_code_description">
      <div class="error_code d-flex flex-column">
        <span class="code">{{ errorCode }}</span>
        <span class="error_type">{{ errorTitle }}</span>
      </div>
      <div class="error_description">
        <span>{{ errorDescription }}</span>
      </div>
      <div class="suggestions">
        <h3>{{ "what_you_can_do" | translate }}</h3>
        @if (errorCode == "400" || errorCode == "408") {
          <ul>
            <li>{{ "check_your_url" | translate }}</li>
            <li>{{ "refresh_page" | translate }}</li>
            <li>{{ "try_again_later" | translate }}</li>
            <li class="cursor-pointer" (click)="navigateToHome()">
              {{ "go_back_to" | translate }} <b class="bold">{{ "home_page" | translate }} </b>
            </li>
          </ul>
        }
        @if (errorCode == "403") {
          <ul>
            <li>{{ "double_check_your_credentials" | translate }}</li>
            <li>{{ "make_sure_you_are_logged_in" | translate }}</li>
            <li>
              <b class="bold">{{ "contact_us" | translate }} </b>{{ "if_you_need_assistance" | translate }}
            </li>
            <li class="cursor-pointer" (click)="navigateToHome()">
              {{ "go_back_to" | translate }} <b class="bold">{{ "home_page" | translate }} </b>
            </li>
          </ul>
        }
        @if (errorCode == "404") {
          <ul>
            <li>{{ "check_your_url" | translate }}</li>
            <li>{{ "refresh_page" | translate }}</li>
            <li>
              <b class="bold">{{ "contact_us" | translate }} </b>{{ "if_you_need_assistance" | translate }}
            </li>
            <li class="cursor-pointer" (click)="navigateToHome()">
              {{ "go_back_to" | translate }} <b class="bold">{{ "home_page" | translate }} </b>
            </li>
          </ul>
        }
        @if (errorCode == "500") {
          <ul>
            <li>{{ "check_your_url" | translate }}</li>
            <li>{{ "use_different_browser_or_device" | translate }}</li>
            <li>
              <b class="bold">{{ "contact_us" | translate }} </b>{{ "if_you_need_assistance" | translate }}
            </li>
            <li class="cursor-pointer" (click)="navigateToHome()">
              {{ "go_back_to" | translate }} <b class="bold">{{ "home_page" | translate }} </b>
            </li>
          </ul>
        }
      </div>
      <div class="quick_tip">
        <h3>{{ "quick_tip" | translate }}</h3>
        <p>{{ quickTip }} </p>
      </div>
    </div>
    <div class="error_image">
      <img
        [src]="'https://cdn.medullar.com/images/web/images/' + (errorCode == '408' ? '403' : errorCode) + '.svg'"
        alt=""
      />
    </div>
  </div>
</div>
